// ;(function($, window, undefined){
//   "use strict";

//   function init() {
//     var window_height, window_width;
//     window_width = 505;
//     window_height = 370;
//     return $('body').on("click", '[data-share-social]', function(_e) {
//       var $el, __left, __opts, __top, __type;
//       _e.preventDefault();
//       $el = $(this);
//       __type = $el.attr('data-share-social');
//       __left = ($(window).width() - window_width) / 2;
//       __top = ($(window).height() - window_height) / 2;
//       __opts = "status=1" + ",width=" + window_width + ",height=" + window_height + ",top=" + __top + ",left=" + __left;
//       window.open($el.attr("href"), $el.attr('data-share-social'), __opts);
//     });
//   }

//   // if (window.SITE.isPage('single-post'))
//   init();

// })(jQuery, window);


SITE.Sharebar = {

   init: function() {
      var window_height, window_width;
      window_width = 505;
      window_height = 370;
      
      $('body').on("click", '[data-share-social]', function(_e) {
        var $el, __left, __opts, __top, __type;
        _e.preventDefault();
        $el = $(this);
        __type = $el.attr('data-share-social');
        __left = ($(window).width() - window_width) / 2;
        __top = ($(window).height() - window_height) / 2;
        __opts = "status=1" + ",width=" + window_width + ",height=" + window_height + ",top=" + __top + ",left=" + __left;
        window.open($el.attr("href"), $el.attr('data-share-social'), __opts);
      });
  }
};